<template>
  <div class="home">
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Dashboard

      <div
        slot="right"
        class="navbar-message button-gap-right-aligned"
        data-recording-sensitive
      >
        Welcome {{ userFirstName }}
      </div>
      <b-field
        v-if="isUserAdmin"
        slot="right"
        class="no-margin-bottom button-gap-right-aligned view-data"
      >
        <b-select
          name="viewData"
          v-model="selectedViewOption"
          v-on:input="viewDataEvent"
          v-bind:isHoverable="true"
          expanded
          class="is-primary"
        >
          <option
            class="view-data-options"
            v-for="(option, index) in viewDataOptions"
            :value="option"
            :key="index"
            selected
          >
            {{ option }}
          </option>
        </b-select>
      </b-field>
      <b-dropdown
        :close-on-click="false"
        position="is-bottom-left"
        aria-role="list"
        slot="right"
        class="button-gap-right-aligned drop-home"
      >
        <template #trigger="{ active }">
          <b-button
            label="My Uploads"
            type="is-primary"
            :icon-right="active ? 'chevron-up' : 'chevron-down'"
          />
        </template>
        <b-dropdown-item aria-role="listitem" has-link
          ><router-link :to="{ name: 'dashboard.uploadedData' }">
            Uploaded Data
          </router-link></b-dropdown-item
        >

        <b-dropdown-item
          aria-role="listitem"
          @click="uploadFormModal"
          v-if="enableUploads()"
          >Upload New Data</b-dropdown-item
        >

        <b-dropdown-item
          v-if="hideComponent"
          aria-role="listitem"
          @click="downloadInternalUserManualFunc"
          >Instruction for Internal Users</b-dropdown-item
        >

        <b-dropdown-item
          v-if="this.isUserExternal"
          aria-role="listitem"
          @click="downloadExternalUserManualFunc"
          >Instruction for External Users</b-dropdown-item
        >

        <b-dropdown-item v-if="this.isUserExternal" aria-role="listitem">
          <b-dropdown>
            <template #trigger>
              <a>
                <span>Templates </span>
                <b-icon icon="menu-down"></b-icon>
              </a>
            </template>
            <b-dropdown-item aria-role="listitem" @click="exportCDFTemplate"
              >Download CDF Template (Product Data)</b-dropdown-item
            >
            <b-dropdown-item
              aria-role="listitem"
              @click="exportCDFTransactionTemplate"
              >Download CDF Template (Transaction Data)</b-dropdown-item
            >
          </b-dropdown>
        </b-dropdown-item>
      </b-dropdown>
    </hero-bar>
    <upload-data-form
      :is-active="isModalActive"
      :account-id="Number(userId)"
      :allCustomers="customers"
      :allCountries="allcountry"
      :allContainers="containers"
      @confirm="uploadFormConfirm"
      @cancel="uploadFormCancel"
    />
    <section class="section is-main-section">
      <div class="columns is-desktop">
        <div class="column is-two-thirds-fullhd">
          <report-status-overview
            :statusData="reportStatusObj"
          ></report-status-overview>

          <div class="columns">
            <div
              class="column is-one-third-desktop is-one-third-widescreen is-half-fullhd"
            >
              <report-list
                :defaultView="default_view"
                :hideCustomerView="hideComponent"
                :allUserMap="userMap"
              ></report-list>
            </div>
            <div
              class="column is-one-third-desktop is-one-third-widescreen is-half-fullhd"
            >
              <updates-list
                :defaultView="default_view"
                :hideCustomerView="hideComponent"
                :allUsers="users"
              ></updates-list>
            </div>
            <div
              class="column is-hidden-tablet-only is-one-third-desktop is-one-third-widescreen is-hidden-fullhd"
            >
              <activities
                v-if="hideComponent"
                :defaultView="default_view"
                :allUserMap="userMap"
                :allUsers="users"
              ></activities>
              <events-external
                v-else
                :defaultView="default_view"
                :hideCustomerView="hideComponent"
              ></events-external>
            </div>
          </div>
        </div>

        <!-- Activities -->
        <div
          class="column is-hidden-mobile is-full-tablet is-hidden-desktop-only is-hidden-widescreen-only is-one-third-fullhd"
        >
          <activities
            v-if="hideComponent"
            :defaultView="default_view"
            :allUserMap="userMap"
            :allUsers="users"
            :allCustomers="customers"
          ></activities>
          <events-external
            v-else
            :defaultView="default_view"
            :hideCustomerView="hideComponent"
          ></events-external>
        </div>
      </div>

      <div
        class="columns is-multiline margin-bottom-large"
        v-if="!isUserExternal"
      >
        <div
          class="column is-full-tablet is-full-widescreen is-three-fifths-fullhd is-mobile"
        >
          <events :defaultView="default_view"></events>
        </div>
        <div
          class="column is-full-tablet is-full-widescreen is-two-fifths-fullhd is-mobile"
        >
          <report-by-country
            v-if="hideComponent"
            :records="reportByCountryData"
          ></report-by-country>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HeroBar from "@/components/HeroBar";
import TitleBar from "@/components/TitleBar";
import ReportStatusOverview from "@/components/Dashboard/ReportStatusOverview";
import ReportByCountry from "@/components/Dashboard/ReportByCountry";
import UploadDataForm from "@/components/Dashboard/UploadDataForm.vue";
import CountryDataService from "../services/CountryDataService";
import DashboardDataService from "../services/DashboardDataService";
import ContainerDataService from "../services/ContainerDataService";
import SchemeDataService from "../services/SchemeDataService";
import UserDataService from "../services/UserDataService";
import CustomerProfileDataService from "../services/CustomerProfileDataService";
import ReportList from "@/components/Dashboard/ReportList.vue";
import updatesList from "@/components/Dashboard/UpdatesList.vue";
import activities from "@/components/Dashboard/RecentActivities.vue";
import events from "@/components/Dashboard/EventCalendar.vue";
import eventsExternal from "@/components/Dashboard/EventCalenderExternalCustomer.vue";
import { UserGroup } from "../services/UserGroups";
import UtilityMixin from "@/mixins/UtilityMixin";
import scopeMixin from "@/mixins/scopeMixin";
import CDFProductDataService from "../services/CDFProductDataService";
import CDFTransactionDataService from "../services/CDFTransactionDataService";

export default {
  name: "Home",
  mixins: [UtilityMixin, scopeMixin],
  components: {
    HeroBar,
    TitleBar,
    ReportStatusOverview,
    UploadDataForm,
    ReportByCountry,
    ReportList,
    updatesList,
    activities,
    events,
    eventsExternal
  },
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "userGroups",
      "isUserExternal",
      "switchCustomerView"
    ]),
    titleStack() {
      return [{ url: "/", name: "Dashboard" }];
    },
    isUserAdmin() {
      if (this.userGroups.includes(UserGroup.EPR_ADMIN)) {
        return true;
      }
      return false;
    },
    userFirstName() {
      if (this.userName) return this.userName.split(" ")[0];
      return "";
    },

    hideComponent() {
      if (
        this.isUserExternal ||
        this.switchCustomerView ||
        this.switchCustomerViewEnabled
      ) {
        return false;
      }
      return true;
    }
  },
  data() {
    return {
      screenPixelSize: true,
      isModalActive: false,
      selectDisable: false,
      selectedViewOption: "View My Data Only",
      default_view: true,
      viewDataOptions: ["View My Data Only", "View All Data"],
      countryDataService: new CountryDataService(),
      userDataService: new UserDataService(),
      customerDataService: new CustomerProfileDataService(),
      containerDataService: new ContainerDataService(),
      schemeDataService: new SchemeDataService(),
      dashboardDataService: new DashboardDataService(),
      reportByCountryData: [],
      allcountry: [],
      allSchemes: [],
      containers: [],
      //users: [],
      customers: [],
      countryCodeMap: {},
      reportStatusObj: {},
      switchCustomerViewEnabled: false,
      switchCustomerId: null,
      CDFProductDataService: new CDFProductDataService(),
      CDFTransactionDataService: new CDFTransactionDataService()
    };
  },
  watch: {
    countries(newValue) {
      this.allcountry = newValue;
      this.fetchCountryList();
      this.fetchReportStatusOverview();
    }
  },
  mounted() {
    if (localStorage.getItem("defaultView")) {
      this.default_view = JSON.parse(localStorage.getItem("defaultView"));
      if (!this.default_view) {
        this.selectedViewOption = "View All Data";
      }
    }

    if (screen.width >= 1408) {
      this.screenPixelSize = true;
    } else {
      this.screenPixelSize = false;
    }
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerViewEnabled =
        switchCustomerData["isSwitchCustomerView"];
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
      this.fetchCustomerProfileData(this.switchCustomerId, true);
    } else {
      this.fetchCustomerProfileData();
    }
    this.fetchCountries();
    this.fetchSchemes();
    this.fetchContainers();
    this.fetchUserData();
  },

  methods: {
    enableUploads() {
      if (this.userGroups.includes(UserGroup.VIEW_ONLY)) {
        return false;
      }

      return true;
    },
    uploadFormModal() {
      this.isModalActive = true;
    },
    uploadFormConfirm() {
      this.isModalActive = false;
    },
    uploadFormCancel() {
      this.isModalActive = false;
    },
    exportCDFTemplate() {
      try {
        this.CDFProductDataService.cdfTemplateExport(this.switchCustomerId);
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    downloadExternalUserManualFunc() {
      try {
        this.customerDataService.downloadUserManual(
          this.switchCustomerId,
          "external"
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    downloadInternalUserManualFunc() {
      try {
        this.customerDataService.downloadUserManual(
          this.switchCustomerId,
          "internal"
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    exportCDFTransactionTemplate() {
      try {
        this.CDFTransactionDataService.cdfTransactionTemplateExport(
          this.switchCustomerId
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    viewDataEvent(option) {
      if (option == "View My Data Only") {
        this.default_view = true;
      } else {
        this.default_view = false;
      }
      localStorage.setItem("defaultView", JSON.stringify(this.default_view));
      this.fetchReportStatusOverview();
    },
    fetchCountryList() {
      this.countryCodeMap = Object.assign(
        {},
        ...this.countries.map(x => ({ [x.id]: x.code }))
      );
    },

    prepareReportByCountryData(data) {
      const reportsbyCountryList = [];
      let reportCountryobj = {
        code: null,
        id: null,
        report_completion_percent: null,
        completed_reports: null,
        total_reports: null
      };

      for (const idx in data) {
        const dataDict = data[idx];
        if (dataDict["total_count"] <= 0) {
          continue;
        }

        reportCountryobj["code"] = this.countryCodeMap[
          dataDict["customer_scheme__scheme__country"]
        ];
        reportCountryobj["id"] = dataDict["customer_scheme__scheme__country"];
        reportCountryobj["completed_reports"] = dataDict["completed_count"];
        reportCountryobj["total_reports"] = dataDict["total_count"];
        reportCountryobj["report_completion_percent"] = Math.round(
          (dataDict["completed_count"] / dataDict["total_count"]) * 100
        );

        reportsbyCountryList.push(reportCountryobj);
        reportCountryobj = {};
      }

      this.reportByCountryData = reportsbyCountryList;
    },
    prepareReportStatusOverview(data) {
      this.reportStatusObj = {
        overdue_reports: data["overdue_reports"],
        due_reports: data["due_reports"],
        completed_reports: data["completed_reports"],
        total_reports: data["total_reports"],
        overdue_past_periods_reports: data["overdue_past_periods_reports"]
      };
    },
    prepareReportsData(data) {
      this.prepareReportStatusOverview(data);
      this.prepareReportByCountryData(data["reports_by_country"]);
    },
    fetchReportStatusOverview() {
      const reportStatusObserve = this.dashboardDataService.getReportStatusOverview(
        this.default_view,
        this.switchCustomerId
      );

      reportStatusObserve.subscribe(
        response => {
          this.prepareReportsData(response);
        },
        e => {
          console.log(e);
        }
      );
      return reportStatusObserve;
    }
  }
};
</script>
